/** All four metadata layers are present. Explicit zero/false are authored values.
 * Read through the caller's resolved-definition reader; missing metadata is not
 * evidence that an unavailable definition is an ordinary passive.
 */
export function isAuraEffect<T>(ctx: { read: { value: (row: T, key: string) => unknown } }, ability: T): boolean {
  return ['aoe_type', 'aoe_distance', 'persistent_aoe', 'aoe_follows_target'].every(key => ctx.read.value(ability, key) != null);
}
